// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from '../../Modals/Modal';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import '../../../styles/forms.css'; 
import '../../../styles/investments-filters.css';
import '../../../styles/forms.css';

export default class BulkEdit extends Modal {

    state = {
    
    }

    componentDidMount = () => {
        // Build the config object...
        const config = {}; 
        this.props.data.config.forEach((c => {
            config[c.key] = c.value??c.default??{label: "", value: ""}; 
        }))

        this.setState({config});
    }

    renderConfig = (c) => {
        const type = c.type; 

        if(type === 'select') {
            return (
                <div
                    className='config'
                >
                    <label>{c.label}</label>
                    <Select 
                        className="filter-selector-container"
                        classNamePrefix='filter-selector'
                        value={this.state.config?.[c.key]??{label: "", value: ""}}
                        options={[...c.options]}
                        onChange={v => {
                            const config = {...this.state.config};
                            config[c.key] = v;
                            this.setState({config});
                        }}
                    />
                </div>
            )
        }

        if(type === 'creatable') {
            return (
                <div
                    className='config'
                >
                    <label>{c.label}</label>
                    <CreatableSelect 
                        className="filter-selector-container"
                        classNamePrefix='filter-selector'
                        value={this.state.config?.[c.key]??{label: "", value: ""}}
                        options={[...c.options]}
                        onChange={v => {
                            const config = {...this.state.config};
                            config[c.key] = v;
                            this.setState({config});
                        }}
                    />
                </div>
            )
        }
    }


    renderContent = () => {
        const d = this.props.data ? this.props.data : {};
        return (
            <div
                className="modal-content modal-center"
            >
                <div style={{height: 160}}/>
                <h1>{d.title}</h1>
                <h2>{d.message}</h2>

                <div
                    className='config-form'
                >
                    {
                        d.config.map((c, i) => {
                            return this.renderConfig(c); 
                        })
                        //     return (
                        //         <div
                        //             className='config'
                        //         >
                        //             <label>{c.label}</label>
                        //             <Select 
                        //                 className="filter-selector-container"
                        //                 classNamePrefix='filter-selector'
                        //                 value={this.state.config?.[c.key]??{label: "", value: ""}}
                        //                 options={[...c.options]}
                        //                 onChange={v => {
                        //                     const config = {...this.state.config};
                        //                     config[c.key] = v;
                        //                     this.setState({config});
                        //                 }}
                        //             />
                        //             {
                        //                 c.hint && 
                        //                 <div
                        //                     className='hint'
                        //                 >
                        //                     {c.hint}
                        //                 </div>
                        //             }
                        //         </div>
                        //     )
                        // })
                    }
                </div>

                <input
                    className="import-config-button"
                    style={{
                        marginLeft: 0, 
                        float: 'none',
                        width: 220
                    }}
                    type="submit"
                    value="Save Changes"
                    onClick={() => {
                        let config = {};
                        
                        Object.keys(this.state.config).forEach(k => {
                            config[k] = this.state.config[k].value;
                        }); 

                        d.onSave(config); 
                        this.props.modal("");
                    }}
                />
            </div>
        );
    }
};